export const download = (document: Document, blob: Blob, filename: string): void => {
	const url = URL.createObjectURL(blob)
	const link = document.createElement("a")
	link.href = url
	link.setAttribute("download", filename)
	document.body.appendChild(link)
	link.click()
	URL.revokeObjectURL(url)
	document.body.removeChild(link)
}

export const base64ToBlob = (base64: string, type: string) => {
	const bin = atob(base64)
	const buffer = new Uint8Array(bin.length)
	for (let i = 0; i < bin.length; i++) {
		buffer[i] = bin.charCodeAt(i)
	}
	const blob = new Blob([buffer.buffer], { type })
	return blob
}
